export default {"src":"/_next/static/media/helloeroBlack.41e15c04.svg","height":117,"width":401,"blurWidth":0,"blurHeight":0};